import { axiosInstance } from 'api/apiConfig'
import { useQuery, useMutation } from 'react-query'
import { objectToQueryString } from 'utils/object-to-query-string'

const notificationList = async (params) => {
  const { data } = await axiosInstance.get(
    `/api/common/notification/v1.0/selectNotificationLst${objectToQueryString(params)}`,
  )
  return data
}

// 알림개수
const notificationCnt = async (params) => {
  const { data } = await axiosInstance.get(
    `/api/common/notification/v1.0/selectNotificationCnt${objectToQueryString(params)}`,
  )
  return data
}

// 알림목록 받는사람
export const useNotificationList = (params, isInit) => {
  return useQuery(['notificationList'], () => notificationList(params), {
    enabled: isInit,
  })
}

// 알림목록 받는사람 개수
export const useNotificationCount = (params, isInit) => {
  return useQuery(['notificationCount'], () => notificationCnt(params), {
    enabled: isInit,
  })
}

//공유하기 확인
const notificationConfirm = async (params) => {
  const { data } = await axiosInstance.post('/api/common/notification/v1.0/confirm', params)
  return data
}

export const useNotificationConfirm = ({ successHandler, errorHandler }) => {
  return useMutation((params) => notificationConfirm(params), {
    onSuccess: ({ data }) => {
      successHandler(data)
    },
    onError: (error) => {
      errorHandler(error)
    },
  })
}
